import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { focusFirstDescendant as k, focusLastDescendant as B } from "./utils.js";
import { createId as I } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { on as x, off as S } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { resolveTo as g } from "../../shared/resolve-to.js";
import { getPreciseEventTarget as L } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { defineComponent as R, onMounted as A, watch as C, onBeforeUnmount as M, h as v, Fragment as _ } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as T } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
let l = [];
const j = R({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: !0
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: !0
    }
  },
  setup(n) {
    const i = I(), u = T(null), E = T(null);
    let s = !1, o = !1;
    const F = typeof document == "undefined" ? null : document.activeElement;
    function a() {
      return l[l.length - 1] === i;
    }
    function d(e) {
      var t;
      e.code === "Escape" && a() && ((t = n.onEsc) === null || t === void 0 || t.call(n, e));
    }
    A(() => {
      C(() => n.active, (e) => {
        e ? (y(), x("keydown", document, d)) : (S("keydown", document, d), s && b());
      }, {
        immediate: !0
      });
    }), M(() => {
      S("keydown", document, d), s && b();
    });
    function h(e) {
      if (!o && a()) {
        const t = m();
        if (t === null || t.contains(L(e)))
          return;
        r("first");
      }
    }
    function m() {
      const e = u.value;
      if (e === null)
        return null;
      let t = e;
      for (; t = t.nextSibling, !(t === null || t instanceof Element && t.tagName === "DIV"); )
        ;
      return t;
    }
    function y() {
      var e;
      if (!n.disabled) {
        if (l.push(i), n.autoFocus) {
          const { initialFocusTo: t } = n;
          t === void 0 ? r("first") : (e = g(t)) === null || e === void 0 || e.focus({ preventScroll: !0 });
        }
        s = !0, document.addEventListener("focus", h, !0);
      }
    }
    function b() {
      var e;
      if (n.disabled || (document.removeEventListener("focus", h, !0), l = l.filter((c) => c !== i), a()))
        return;
      const { finalFocusTo: t } = n;
      t !== void 0 ? (e = g(t)) === null || e === void 0 || e.focus({ preventScroll: !0 }) : n.returnFocusOnDeactivated && F instanceof HTMLElement && (o = !0, F.focus({ preventScroll: !0 }), o = !1);
    }
    function r(e) {
      if (a() && n.active) {
        const t = u.value, c = E.value;
        if (t !== null && c !== null) {
          const f = m();
          if (f == null || f === c) {
            o = !0, t.focus({ preventScroll: !0 }), o = !1;
            return;
          }
          o = !0;
          const D = e === "first" ? k(f) : B(f);
          o = !1, D || (o = !0, t.focus({ preventScroll: !0 }), o = !1);
        }
      }
    }
    function p(e) {
      if (o)
        return;
      const t = m();
      t !== null && (e.relatedTarget !== null && t.contains(e.relatedTarget) ? r("last") : r("first"));
    }
    function w(e) {
      o || (e.relatedTarget !== null && e.relatedTarget === u.value ? r("last") : r("first"));
    }
    return {
      focusableStartRef: u,
      focusableEndRef: E,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus: p,
      handleEndFocus: w
    };
  },
  render() {
    const { default: n } = this.$slots;
    if (n === void 0)
      return null;
    if (this.disabled)
      return n();
    const { active: i, focusableStyle: u } = this;
    return v(_, null, [
      v("div", {
        "aria-hidden": "true",
        tabindex: i ? "0" : "-1",
        ref: "focusableStartRef",
        style: u,
        onFocus: this.handleStartFocus
      }),
      n(),
      v("div", {
        "aria-hidden": "true",
        style: u,
        ref: "focusableEndRef",
        tabindex: i ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
});
export {
  j as FocusTrap
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/focus-trap/src/index.js
// module id = 950
// module chunks = 41